(function(){
    'use strict'

    angular
    .module('app.reportes')
    .controller('reportes.ResultadosPremiacion', ResultadosPremiacion);

    ResultadosPremiacion.$inject = ['$scope', '$animationsSrv', 'ApiBaseService', 'logger'];

    function ResultadosPremiacion($scope, $animationsSrv, ApiBaseService, logger) {
    
        $animationsSrv.scrollToTop();
        ApiBaseService.remoteController = 'api/Inscripciones'

        const ESTADO_CONFIRMADO = 2;

        var vm = this;

        vm.criteriosBusqueda = {
            eventoId: 0,
            estado: ESTADO_CONFIRMADO,
            usuarioId: 0,
            inscriptorId: 0,
            categoriaId: 0,
            nombre: '0',
            apellidos: '0',
            apellido2: '0',
            cantidad: 5
        };

        vm.categorias = [];
        vm.eventos = [];

        vm.collection = [];
        vm.title = 'Reporte de Premiación';

        getComboData(vm.eventos, 'api/Eventos/All', null, 'Error al cargar los eventos');

        function getReportRemoteController(page)
        {
            return `api/reportes-inscripciones/${page}`;
        };

        vm.clearCriteria = function()
        {
            vm.criteriosBusqueda = {
                eventoId: 0,
                estado: ESTADO_CONFIRMADO,
                usuarioId: 0,
                inscriptorId: 0,
                categoriaId: 0,
                nombre: '0',
                apellidos: '0',
                apellido2: '0',
                cantidad: 5
            };
        };

        vm.getAll = function()
        {
            $scope.submitted = true;
            doFormValidations();

            if($scope.dataForm.$valid){
                getAll();
            }
        };

        function getAll(){
            ApiBaseService.remoteController = getReportRemoteController('all-premiacion');

            const criterios = [
                vm.criteriosBusqueda.eventoId,
                vm.criteriosBusqueda.categoriaId,
                vm.criteriosBusqueda.cantidad,
            ];

            var promise = ApiBaseService.getAll(criterios);

            promise
            .then(function(collection){

                collection.forEach((c)=>{
                    c.verDetalle =  false;
                });

                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function doFormValidations()
        {
            validateSelectProperty($scope.dataForm, vm.criteriosBusqueda, 'eventoId' );
        };

        vm.getExcel = function(tipoReporte)
        {
            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                ApiBaseService.remoteController = getReportRemoteController(tipoReporte);

                const criterios = [
                    vm.criteriosBusqueda.eventoId,
                    vm.criteriosBusqueda.estado,
                    vm.criteriosBusqueda.inscriptorId,
                    vm.criteriosBusqueda.categoriaId,
                    vm.criteriosBusqueda.cantidad
                ];
    
                var promise = ApiBaseService.getFile(criterios);
    
                promise
                .then(function(result){
                    logger.info('Excel descargado!');
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                    
                        default:
                            logger.error('Error al obtener los datos.');
                            break;
                    }
                });  
            }      
        };

        vm.getPDF = function(tipoReporte)
        {
            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                ApiBaseService.remoteController = getReportRemoteController(tipoReporte);

                const criterios = [
                    vm.criteriosBusqueda.eventoId,
                    vm.criteriosBusqueda.estado,
                    vm.criteriosBusqueda.inscriptorId,
                    vm.criteriosBusqueda.categoriaId,
                    vm.criteriosBusqueda.cantidad
                ];
    
                var promise = ApiBaseService.getFile(criterios);
    
                promise
                .then(function(result){
                    logger.info('PDF descargado!');
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                    
                        default:
                            logger.error('Error al obtener los datos.');
                            break;
                    }
                });  
            }      
        };

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "eventoId":
                    onEventoIdChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onEventoIdChanged(property)
        {
            const result = validateSelectProperty($scope.dataForm, vm.criteriosBusqueda, property );

            vm.criteriosBusqueda.categoriaId = 0;
            vm.categorias = [];

            if(result)
            {
                getComboData(vm.categorias, 'api/EventosCategorias', [vm.criteriosBusqueda.eventoId], 'Error al cargar las Categorias');
            }
        };

    }
})();